import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";

declare var ko: any;

export class modPointsReportByUser_template extends vnTemplate {

    protected filter: filterSimple_template;
    protected pagination: pagination_template;
    protected resultInfos: resultsInfo_template;

    protected getTemplateHtml(): string {

        return `


            

            <div class="list-header w-justify" >

                <div class="w-left" style="width:100%;background-color:#FFFFFF;padding: 10px;border-radius:3px;">
                    <div class="w-form-body">

                        <div class="form-body">
                            <div class="form-group" style="display:block;">
                                <dl class="double-list margin">
                                    <dt class=""><span>Modder</span></dt>
                                    <dd class=""><span data-bind="text: displayName||''"></span></dd>
                                    <dt class=""><span>Total Points</span></dt>
                                    <dd class=""><span data-bind="text: totalPoints||''"></span></dd>
                                    <dt class=""><span>Modder ID</span></dt>
                                    <dd class="" data-bind="event: { click: onClickView }"><a class="right-click" style="cursor:pointer"><span data-bind="text: idAccessPointUser"></span></a></dd>
                                </dl>
                            </div>
                        </div>

                    </div>
                </div>

                <div class="w-right">
                    ` + this.pagination.getHtmlBuild() + `
                </div>
            </div>

            <div class="w-list-results" id="list-results">
                <table class="list-results">
                    ` + this.resultInfos.getHtmlBuild() + `
                    
                    <thead>
                        <tr>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'points') }, css: { 'list-sort-desc': orderByAndDirection()=='points_DESC', 'list-sort-asc': orderByAndDirection()=='points_ASC' }">Earned Points</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'actionName') }, css: { 'list-sort-desc': orderByAndDirection()=='actionName_DESC', 'list-sort-asc': orderByAndDirection()=='actionName_ASC' }">Action</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'description') }, css: { 'list-sort-desc': orderByAndDirection()=='description_DESC', 'list-sort-asc': orderByAndDirection()=='description_ASC' }">Action Description</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateAction') }, css: { 'list-sort-desc': orderByAndDirection()=='dateAction_DESC', 'list-sort-asc': orderByAndDirection()=='dateAction_ASC' }">Date</span></th>
    
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: mods">
                        <tr class="cursor">
                            <td ><a class="right-click"><span data-bind="text: points"></span></a></td>
                            <td ><a class="right-click"><span data-bind="text: actionName"></span></a></td>
                            <td ><a class="right-click"><span data-bind="text: description"></span></a></td>
                            <td ><a class="right-click"><span data-bind="text: dateAction"></span></a></td>
                            
                        </tr>
                    </tbody>
                </table>
            </div>

            `;
    }

    protected initPartial(): void {

        this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 20;
        this.resultInfos = new resultsInfo_template("resultInfo", this.getTemplateViewModel(), this.caller);

    }

    protected getTemplateName(): string {
        return "modPointsReportByUser_template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-content"];
    }

    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let huit_neuf_this = this;
        return {
            orderBy: ko.observable("displayName")
            , orderByDirection: ko.observable("ASC")
            , mods: ko.observableArray([])
            //, extraData: ko.observableArray([])
            , totalPoints: ko.observableArray([])
            , displayName: ko.observableArray([])
            , idAccessPointUser: ko.observableArray([])
            , idWebsiteUser: ko.observableArray([])
            , orderByAndDirection: ko.observable("displayName_ASC")
            , isAddButtonShown: ko.observable(true)
            , onClickReorder: function (value, data, event) {
                huit_neuf_this.onClickReorder(value, data, event);
            }
            , onClickAdd: function () {
                huit_neuf_this.onClickAdd();
            }
            , onClickView: function (data) {
                huit_neuf_this.onClickView(data);
            }
            , onClickViewOnSite: function (data) {
                huit_neuf_this.onClickViewOnSite(data);
            }
        };
    }

    // implementation of base class [vnTemplate]
    public getViewModelForRequest() {

        return {
            orderBy: this.getTemplateViewModel().orderBy
            , orderByDirection: this.getTemplateViewModel().orderByDirection
            , orderByAndDirection: this.getTemplateViewModel().orderByAndDirection
            , pagination: this.getTemplateViewModel().pagination
            ,filters : {
                keywords : this.getTemplateViewModel().filter.filterKeyword
            },
        }
    }


    public onClickReorder(value, data, event) {

        data.orderBy(value);
        //if column has already been sorted, flip the direction
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.listReorder();
    }

    public setViewModelFromRequest(urlParams){

        if (urlParams == null){
            return;
        }

        let keywordString = urlParams.keywords
        if(urlParams.keywords){
            keywordString = urlParams.keywords.replaceAll("+", " ");
        }

        this.filter.getTemplateViewModel().filterKeyword(keywordString);
    }

    public setFilterSelectedItems(objFilter, urlParams){

        let splitString = [];

        // Multi select filters.
        if(urlParams){
            if(typeof urlParams == "string"){
                splitString = urlParams.split(",");
            }else if(Array.isArray(urlParams)){
                splitString = urlParams;
            }else{
                splitString = [urlParams];
            }
            let arrayParam = [];
            let idTagArray = [];
            splitString.forEach((id) => {
                if(!isNaN(Number(id))){
                    id = Number(id);
                }else{
                    id = id.replaceAll("+", " ");
                }
                arrayParam.push({ id: id });
                idTagArray.push(id);
            });
            objFilter.setSelectedItems(arrayParam);
            objFilter.setTags(idTagArray, objFilter.getItems());
        }else{
            objFilter.setSelectedItems([]);
            objFilter.setTags([], objFilter.getItems());
        }
    }

    public onClickAdd() {

        this.caller.add();
    }

    public setMods(data) {

        this.getTemplateViewModel().mods(data);
    }

    public setExtraData(data) {
        console.log('extraData',data);

        this.getTemplateViewModel().totalPoints(data.totalPoints);
        this.getTemplateViewModel().displayName(data.displayName);
        this.getTemplateViewModel().idAccessPointUser(data.idAccessPointUser);
        this.getTemplateViewModel().idWebsiteUser(data.idWebsiteUser);
        
    }

    public onClickView(data){

        this.caller.view(data.idWebsiteUser());
    }

    public onClickViewOnSite(data) {

        this.caller.viewOnSite(data);
    }

    public setResultInfo(nbResults, nbPages, execTime ) {

        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

}



// WEBPACK FOOTER //
// ./js/components/templates/modPointsReportByUser_template.ts